<template>
  <ts-dialog
    :data-visible="visible || null"
    type="error"
    notification
    non-dismissable
    primary="accept"
    @accept="visible = false"
    @cancel="visible = false"
  >
    <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
    <div slot="content">
      <h5>
        {{ message }}
      </h5>
      <details
        v-if="errorBody"
        :open="open"
        @toggle="open = $event.target.open"
      >
        <summary>
          <div class="header-group">
            <ts-icon
              class="detail-open-icon"
              icon="arrow-down-short"
              size="large"
              type="slate-lightest"
              :rotate="open ? null : '270'"
            />
            <span>Error details</span>
          </div>
          <ts-button
            @button-click="copyToClipboard"
            type="secondary"
            size="micro"
          >
            Copy
          </ts-button>
        </summary>

        <div class="error-body">
          {{ errorBody }}
        </div>
      </details>
    </div>
  </ts-dialog>
</template>

<script>
import '@tradeshift/elements.dialog';

export default {
  data() {
    return {
      visible: false,
      message: 'Something went wrong',
      errorBody: null,
      open: false,
    };
  },
  created() {
    this.$eventBus.on('show-error', this.showError);
  },
  beforeUnmount() {
    this.$eventBus.off('show-error');
  },
  methods: {
    showError({ message, errorBody }) {
      this.visible = true;
      this.message = message;
      this.errorBody = errorBody;
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.errorBody);
    },
  },
};
</script>

<style scoped>
details summary::-webkit-details-marker,
details summary::marker {
  display: none;
  content: '';
}

details {
  width: 100%;
  text-align: left;
  margin-top: var(--ts-unit-plus);
  color: var(--ts-color-black);
  border-radius: var(--ts-radius);
  border: var(--ts-border);
  box-shadow: var(--ts-board-shadow);
  padding: var(--ts-unit-quarter) 0;
}

summary {
  font-weight: var(--ts-fontweight-semibold);
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding-right: var(--ts-unit-quarter);
}

.error-body {
  border-top: var(--ts-border);
  padding: var(--ts-unit-quarter);
  max-height: 50vh;
  overflow: auto;
}

.header-group {
  display: flex;
  justify-content: flex-start;
  text-align: center;
}
</style>
